import { render, staticRenderFns } from "./DesignModal.vue?vue&type=template&id=5465ea92&scoped=true&"
import script from "./DesignModal.vue?vue&type=script&lang=js&"
export * from "./DesignModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignModal.vue?vue&type=style&index=0&id=5465ea92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465ea92",
  null
  
)

export default component.exports